import {
  getSpecCombinationListFromVariants,
  getSpecListFromConfigurableOptions,
} from "@/lib/sku-algorithm/lib/get-instock-value-indexes"
import SpecAdjoinMatrix from "@/lib/sku-algorithm/utils/spec-adjoin-martix"
import { isProductConfigurable } from "@/util/isProductConfigurable"
import { useState } from "react"
import { useGetInstockFabricOptions } from "../components/use-get-instock-fabric-options"

export const useOptionsSpecs = ({ product }: { product: any }) => {
  // 不存在缺货问题, 所有顶点可选
  const ampOptionSpecs = product?.ampProtOption?.items
    ?.map((item: any) => {
      return item.values.map((value: any) => {
        return value.value_index.toString()
      })
    })
    .flat()

  const isConfigurable = isProductConfigurable(product)

  const specList = isConfigurable
    ? getSpecListFromConfigurableOptions(product?.configurable_options)
    : []
  const specCombinationList = isConfigurable
    ? getSpecCombinationListFromVariants(product?.variants)
    : []

  const fabricOptions = product?.configurable_options?.filter(
    (item: any) =>
      item?.label === "Fabric" &&
      Array.isArray(item?.values) &&
      item.values.length > 0
  )
  const colorOptions = product?.configurable_options?.filter(
    (item: any) =>
      item?.label === "Color" &&
      Array.isArray(item?.values) &&
      item.values.length > 0
  )

  const oldFabricOptionValues = fabricOptions?.[0]?.values || []

  const { values: fabricOptionValues } = useGetInstockFabricOptions({
    product,
    oldValues: oldFabricOptionValues,
  })

  const [specsS, setSpecsS] = useState(() => {
    try {
      const firstSpec = Array(specList?.length || 0).fill("")

      if (
        Array.isArray(fabricOptions) &&
        fabricOptions.length > 0 &&
        fabricOptionValues?.[0]?.value_index !== null
      ) {
        firstSpec[0] = String(fabricOptionValues[0].value_index)

        return firstSpec
      }

      // if (Array.isArray(fabricOptions) && fabricOptions.length > 0) {
      //   // 有 fabric 选项

      //   if (Array.isArray(colorOptions) && colorOptions.length > 0 && colorOptions?.[0]?.values?.[0]?.value_index !== null) {
      //     firstSpec[0] = String(colorOptions[0].values[0].value_index);

      //     return firstSpec;
      //   }
      // }

      return firstSpec
    } catch (error) {
      console.error("Error initializing specs state:", error)

      return Array(specList.length).fill("")
    }
  })

  // 创建一个规格矩阵
  const specAdjoinMatrix = new SpecAdjoinMatrix(specList, specCombinationList)
  // 获得可选项表
  const optionSpecs = isConfigurable
    ? specAdjoinMatrix.getSpecscOptions(specsS)
    : ampOptionSpecs

  // console.log({
  //   specsS,
  //   specList,
  //   specCombinationList,
  //   optionSpecs,
  // })

  const handleClick = function ({
    bool,
    text,
    index,
    isFabric,
  }: {
    bool: boolean
    text: string
    index: number
    isFabric?: boolean
  }) {
    if (isFabric) {
      const myArray = Array(specList.length).fill("")

      myArray[index] = text

      setSpecsS(myArray.slice())

      return
    }

    // 排除可选规格里面没有的规格
    if (specsS[index] !== text && !bool) {
      return
    }

    // 根据text判断是否已经被选中了
    specsS[index] = specsS[index] === text ? "" : text
    setSpecsS(specsS.slice())
  }

  return {
    specsS, // 当前选中的顶点
    setSpecsS,
    specList,
    specCombinationList,
    optionSpecs, // 还可选中的顶点
    handleClick,
  }
}
